import React, { createContext, FC, ReactElement, useContext } from 'react';
import { OrderingLocale } from 'kiolyn-api';
import { observable, decorate } from 'mobx';
import { useLocalStore } from 'mobx-react-lite';

interface LocaleConfigProviderProps {
  children: ReactElement;
  locale?: OrderingLocale;
}

class LocaleStore {
  locale: OrderingLocale = {
    locale: 'en-US',
    currency: 'USD'
  };
  formatCurrency(amount: number) {
    if (this.locale.locale === 'point') {
      return amount + ' point(s)';
    }

    const formatter = new Intl.NumberFormat(this.locale.locale, {
      style: 'currency',
      currency: this.locale.currency
    });
    return formatter.format(amount);
  }
}

decorate(LocaleStore, {
  locale: observable
});

export const LocaleConfigProvider: FC<LocaleConfigProviderProps> = ({
  children,
  locale
}: LocaleConfigProviderProps) => {
  const localeStore = useLocalStore(() => new LocaleStore());
  if (locale) {
    Object.assign(localeStore.locale, locale);
  }
  return (
    <LocaleConfigContext.Provider value={localeStore}>
      {children}
    </LocaleConfigContext.Provider>
  );
};

export const LocaleConfigContext = createContext(new LocaleStore());
export const useLocaleConfig = () => useContext(LocaleConfigContext);
